import React from 'react';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import PropTypes from 'prop-types';

import BikeCard from 'widgets/BikeCard';
import { getKey } from 'utils';

import './CityBikesSection.css';
import { patchTo } from '../../../widgets/I18nLink';

const CityBikesSection = ({
  t,
  bikes,
  bikeType,
  bikeTypes,
  city,
  currency,
  onSelect
}) => {
  return (
    <div className="section city-bikes-section">
      <h2>
        {t(`${bikeType.nameEn}s for rent`)}
        {' '}
        {getKey(city, 'name')}
      </h2>

      <Grid>
        <ul className="city-bikes-section-list">
          {bikes.map((bike) => (
            <li
              key={bike.id}
              className="city-bikes-section-item"
            >
              <BikeCard
                average
                bike={bike}
                bikeTypes={bikeTypes}
                currency={currency}
                href={patchTo(`/detail/${bike.id}/`)}
                showBikeLocationLink={false}
                showProvider={false}
                onClick={onSelect}
              />
            </li>
          ))}
        </ul>
      </Grid>
    </div>
  );
};

CityBikesSection.propTypes = {
  bikes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    price: PropTypes.array,
    salesPrice: PropTypes.array,
    bikeType: PropTypes.number
  })),
  bikeTypes: PropTypes.array,
  city: PropTypes.object,
  currency: PropTypes.string,
  lang: PropTypes.string
};

CityBikesSection.defaultProps = {
  bikes: [],
  bikeTypes: [],
  city: null,
  currency: null,
  lang: null
};

export default translate(['bikeTypes', 'cities', 'translation'])(CityBikesSection);



// WEBPACK FOOTER //
// ./src/components/StaticCityPage/CityBikesSection/CityBikesSection.js